/**
 * Converts Slate 0.47 format documents to the current (0.50+) format.
 *
 * Old format:
 *   { object: "value", document: { object: "document", nodes: [
 *     { object: "block", type: "paragraph", nodes: [
 *       { object: "text", text: "hello", marks: [{ type: "bold" }] }
 *     ]}
 *   ]}}
 *
 * New format:
 *   [{ type: "paragraph", children: [{ text: "hello", bold: true }] }]
 */

function migrateNode(node) {
  // Text leaf
  if (node.object === 'text') {
    const leaf = { text: node.text || '' };
    if (Array.isArray(node.marks)) {
      for (const mark of node.marks) {
        leaf[mark.type] = true;
      }
    }
    return leaf;
  }

  // Block or inline element
  if (node.object === 'block' || node.object === 'inline') {
    const element = { type: node.type || 'paragraph' };

    // Preserve any extra properties (e.g., url, data attributes)
    if (node.data && typeof node.data === 'object') {
      Object.assign(element, node.data);
    }

    element.children = Array.isArray(node.nodes) ? node.nodes.map(migrateNode) : [{ text: '' }];

    return element;
  }

  // Unknown node shape — return as-is
  return node;
}

/**
 * If `value` is in the old Slate 0.47 format, convert it to the current format.
 * If it's already an array (current format), return it unchanged.
 * Returns null for null/undefined input.
 */
export default function migrateSlateValue(value) {
  if (value == null) return null;
  if (Array.isArray(value)) return value;

  // Detect old format: { object: "value", document: { nodes: [...] } }
  if (value.object === 'value' && value.document && Array.isArray(value.document.nodes)) {
    console.warn(
      '[migrateSlateValue] Converting legacy Slate 0.47 document to current format.',
      'Top-level nodes:',
      value.document.nodes.length
    );
    return value.document.nodes.map(migrateNode);
  }

  // Unrecognized format — return as-is and let Slate's own validation catch it
  return value;
}
